import {
    groupLifeProposalsService,
    type ListGroupLifeProposalVersionsResponse,
} from '@/services/proposals/group-life';
import { useQuery } from '@tanstack/react-query';

export function useGroupLifeProposalVersions(policyId?: string) {
  return useQuery({
    queryKey: ['group-life-proposal', 'versions', policyId],
    queryFn: async (): Promise<ListGroupLifeProposalVersionsResponse> => {
      if (!policyId) throw new Error('policyId é obrigatório');
      const result = await groupLifeProposalsService.listProposalVersions(
        policyId
      );
      if (!result.success || !result.data) {
        throw new Error(result.error ?? 'Falha ao carregar as versões');
      }
      return result.data;
    },
    enabled: !!policyId,
    staleTime: 0,
  });
}